export default {
      id: "flowers-usage",
      viewBox: "0 0 28 31",
      url: __webpack_public_path__ + "img/icons.svg#flowers",
      toString: function () {
        return this.url;
      }
    }